import { combineReducers } from 'redux';
import account from 'reducers/account';
import accounts from 'reducers/accounts';
import firebase from 'reducers/firebase';
import integrationTypes from 'reducers/integrationTypes';
import currentModal from 'reducers/currentModal';
import view from 'reducers/view';
import user from 'reducers/user';
import chromeExtension from 'reducers/chromeExtension';
import billing from 'reducers/billing';
import newBilling from 'reducers/newBilling';
import system from 'reducers/system';
import spoofing from 'reducers/spoofing';
import entitlements from 'reducers/entitlements';

const state = combineReducers({
  account,
  accounts,
  firebase,
  currentModal,
  user,
  view,
  chromeExtension,
  integrationTypes,
  billing,
  newBilling,
  system,
  spoofing,
  entitlements,
});

export default state;
